/*
 * @Author: lcy
 * @Date: 2021-04-22 10:25:06
 * @LastEditTime: 2021-05-14 15:28:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dtpWeb\src\assets\js\customModules\tools.js
 */
var tools = {
  uniqueFunc(arr, key) {
    const res = new Map();
    return arr.filter((arr) => !res.has(arr[key]) && res.set(arr[key], 1))
  },
  copy(val) {
    return JSON.parse(JSON.stringify(val));
  },
  /**
   * 判断对象是否为空
   * @param {*} obj
   */
  empty(obj) {
    for (let key in obj) {
      return false; //非空
    }
    return true; //为空
  }
}
export default {
  tools,
}
